<template>
  <div class="popup" :style="getSyle">
    <div
      style="
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
      "
    >
      <h3 style="margin-bottom: 0">{{ projectName }} - {{ projectCountry }}</h3>
      <div style="display: flex; gap: 12px; align-items: center">
        <span style="cursor: pointer" @click="this.$emit('closePopup')">X</span>
      </div>
    </div>
    <div class="map-wrapper" @click="check">
      <GMapMap
        ref="myMapRef"
        :center="center"
        :zoom="zoom"
        style="width: 100%; height: 100%"
        :options="options"
      >
        <!-- <GMapMarker :position="center" :clickable="true" :icon="projectType.marker_icon" /> -->
        <GMapMarker
          :position="center"
          :clickable="true"
          :icon="{
            url: projectType.marker_icon,
            scaledSize: { width: 16, height: 21 },
          }"
        />
      </GMapMap>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    center: Object,
    projectName: String,
    projectType: Object,
    projectCountry: String,
    changePopUpStyle: {
      default: false,
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {
      options: {
        mapId: '225b2cf3b03a598',
        fullscreenControl: true,
        streetViewControl: false,
      },
      zoom: 8,
    }
  },
  // async mounted() {
  //   fetch('../../../../../assets/projectToShow.geojson')
  //     .then((res) => res.text())
  //     .then(async (geoJsonText) => {
  //       var map = await this.$refs.myMapRef.$mapPromise
  //       const geojson = JSON.parse(geoJsonText)
  //       console.log(geojson)
  //       map.data.addGeoJson(geojson)
  //       await map.data.setStyle((feature) => {
  //         const geometry = feature.getGeometry()
  //         const type = geometry.getType()
  //         const name = feature.getProperty('name')
  //         var iconOfFeature = feature.getProperty('selectedIcon')
  //         var colorOfFeature = feature.getProperty('color')
  //         const fillColor = feature.getProperty('fillColor')
  //         var featureIndex = feature.getProperty('id')

  //         return {
  //           strokeColor: colorOfFeature || '#FF0000',
  //           strokeWeight: 8,
  //           fillColor: fillColor || 'grey',
  //           fillOpacity: 0.5,
  //           icon: iconOfFeature || 'https://maps.google.com/mapfiles/kml/paddle/red-circle.png',
  //           cursor: 'pointer',
  //         }
  //       })
  //     })
  // },
  methods: {
    checkMapTypeId() {
      if (this.$refs.myMapRef) {
        this.$refs.myMapRef.$mapPromise.then((mapObject) => {
          var map = mapObject.getMapTypeId()
          if (map === 'hybrid' || map === 'satellite') {
            this.zoom = 14
          } else {
            this.zoom = 8
          }
        })
      }
    },
    check() {
      this.checkMapTypeId()
    },
  },
  computed: {
    getSyle() {
      if (this.changePopUpStyle) {
        return {
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.popup {
  align-self: center;
  width: 90%;
  background: white;
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 2rem;
  overflow-y: auto;
  box-shadow: 0 1px 2px 0 rgb(60 64 67 / 30%), 0 1px 3px 1px rgb(60 64 67 / 15%);
  transition: box-shadow 0.08s linear,
    min-width 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 100;
  height: 350px;

  .popup-btns {
    margin-top: 8px;
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: #091e4214;
  }
  &::-webkit-scrollbar-thumb {
    background: #091e4214;
  }
  &::-webkit-scrollbar-track {
    background: #091e4214;
    border-radius: 10px;
  }
}
.map-wrapper {
  width: 100%;
  height: 100%;
}

.vue-map-container {
  width: 100%;
  height: 100%;
}
</style>
